<template>
  <div class="border">
    <h4>Модификации</h4>
    <list :columns="columns" :modalCreate="modalCreate" :removeLink="removeLink" :cardLink="cardLink" :isUpdate="true"
      :isAdd="true" :itemLink="itemLink" title_add="Добавить модицикацию" :setLink="setLink" :openItem="false"
      :fields="fields" :params="params" :searchDisable="true" @change="change" @changeFunction="changeFunction"
      v-model="val" />
  </div>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) { },
    change(val) { },
  },
  props: ['id'],
  created() {
    this.itemLink += `/${this.id}/variants`;
    this.setLink += `/${this.id}/variants`;
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "field",
      fields: [
        {
          col: ' col-12 col-md-12',
          key: "name",
          label: "Название (обмен данных)",
          type: "field",
          textType: "text"
        },
        {
          col: ' col-12 col-md-12',
          key: "modification_name",
          label: "Модификация",
          type: "field",
          textType: "text"
        },
        {
          col: ' col-12 col-md-6',
          key: "barcode",
          label: "Баркод",
          type: "field",
          textType: "text"
        },
        {
          col: ' col-12 col-md-6',
          key: "exchange_id",
          label: "Доп. идентификатор",
          type: "field",
          textType: "text"
        },

      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_variant",
      itemLink: "products",
      setLink: "products",
      columns: [
      {
          col: ' col-12 col-md-6',
          key: "barcode",
          title: "Баркод",
          type: "field",
          textType: "text"
        },
        {
          col: ' col-12 col-md-12',
          key: "modification_name",
          title: "Модификация",
          type: "field",
          textType: "text"
        },
       
       
      
        {
          detail: true
        }
      ],
    };
  },
};
</script>